import QartDirective from './angular-qart.directive.js';

export default angular.module('angular-qart', []).directive('angularQart', QartDirective);



// WEBPACK FOOTER //
// ./src/index.js